/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 // ── ADD-ON STADIUM: hide/show variant logic ──────────────────────────
(function() {
  if (!window.location.pathname.includes('/products/')) return;

  const ADDON_PREFIX = 'ADD-ON Stadium:';

  const ADDON_VARIANT_MAP = {
    'original-9':      'ADD-ON Stadium: Original 9" - $99',
    'signature-13':    'ADD-ON Stadium: Signature 13" - $179',
    'show-stopper-19': 'ADD-ON Stadium: Show Stopper 19" - $250'
  };

  let addonData = null;
  try {
    const raw = sessionStorage.getItem('hf_addon');
    if (raw) addonData = JSON.parse(raw);
  } catch(e) {}

  function applyVariantVisibility() {
    document.querySelectorAll('select.single-option-selector').forEach(function(select) {
      Array.from(select.options).forEach(function(option) {
        const title = option.text || '';
        if (addonData) {
          const targetTitle = ADDON_VARIANT_MAP[addonData.size];
          if (title === targetTitle) {
            option.style.display = '';
            option.disabled = false;
            select.value = option.value;
          } else {
            option.style.display = 'none';
            option.disabled = true;
          }
        } else {
          if (title.indexOf(ADDON_PREFIX) === 0) {
            option.style.display = 'none';
            option.disabled = true;
          } else {
            option.style.display = '';
            option.disabled = false;
          }
        }
      });
      select.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  // Run immediately and on intervals
  document.addEventListener('DOMContentLoaded', applyVariantVisibility);
  setTimeout(applyVariantVisibility, 500);
  setTimeout(applyVariantVisibility, 1000);
  setTimeout(applyVariantVisibility, 2000);

  // Watch for DOM changes and re-apply whenever the select is modified
  var observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.target.classList && mutation.target.classList.contains('single-option-selector')) {
        applyVariantVisibility();
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('select.single-option-selector').forEach(function(select) {
      observer.observe(select, { childList: true, subtree: true, attributes: true });
    });
    // Also observe the whole product form for re-renders
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) observer.observe(form, { childList: true, subtree: true });
  });

  document.addEventListener('product:added', function() {
    sessionStorage.removeItem('hf_addon');
  });

})();
// ── END ADD-ON STADIUM variant logic ────────────────────────────────
if (window.location.hash === '#join-the-roster') {
  window.addEventListener('load', function() {
    var popup = document.querySelector('.modal--newsletter');
    if (popup) popup.setAttribute('aria-hidden', 'false');
  });
}
// Redirect Judge.me carousel "View all" link on Fan Photos page only
if (window.location.pathname === '/pages/fan-photos') {
  function fixFanPhotosCarouselLink() {
    document.querySelectorAll('.jdgm-carousel__view-all-link, a[href*="/reviews"], a[href*="judge.me"]').forEach(function(link) {
      if (link.closest('.jdgm-carousel')) {
        link.href = '/pages/fan-photos';
        link.setAttribute('target', '_self');
      }
    });
  }

  // Run on load and after a short delay (in case Judge.me renders async)
  document.addEventListener('DOMContentLoaded', fixFanPhotosCarouselLink);
  setTimeout(fixFanPhotosCarouselLink, 1500);
}

